import { render, staticRenderFns } from "./experience.vue?vue&type=template&id=80607798&scoped=true&"
import script from "./experience.vue?vue&type=script&lang=js&"
export * from "./experience.vue?vue&type=script&lang=js&"
import style0 from "./experience.vue?vue&type=style&index=0&id=80607798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80607798",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
